import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  getMlmfuserMaster,
  getFreeDeliveryListMaster,
  getMlmfoutletMaster,
  getcustomerAdrsIDMaster,
  saveFreeDeliveryREQ,
} from "../../../../apiservicescall/api";
import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import Select from "react-select";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import swal from "sweetalert";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Edit } from "@material-ui/icons";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { de } from "date-fns/locale";

const FreeDelivery = () => {
  const [userlist, setuserlist] = useState([]);
  const [selectedusers, setSelectedusers] = useState([
    { label: "", value: "" },
  ]);

  const [outletlist, setoutletlist] = useState([]);
  const [selectedrestarant, setSelectedrestarant] = useState([
    { label: "", value: "" },
  ]);
  const [CustomerAddresID, setCustomerAddresID] = useState([]);
  const [selectedAdres, setSelectedAdres] = useState([]);

  const [CustomerFreeDely, setCustomerFreeDely] = useState([]);
  const [comonPopupModal, setcomonPopupModal] = useState(false);
  const [deletepopup, setDeletepopup] = useState(false);

  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [errors, setErrors] = useState({
    address: null,
    fromDate: null,
    toDate: null,
  });

  const [formIsValid, setFormIsValid] = useState(false);
  const [startDate, setDate] = useState(new Date());
  const [endDate, setendDate] = useState(new Date());
  const today = new Date();

  const [FreeDelyDetail, setFreeDelyDetail] = useState([{
    outletCode: null,
    customerId: null,
    fromDate: null,
    toDate: null,
    addressId: null,
    status: null
  }
  ]);

  useEffect(() => {
    getuserMaster();
    getRestarantmaster();
  }, []);

  const getuserMaster = async () => {
    let getsuserList = await getMlmfuserMaster();

    let getsuserValue = (getsuserList && getsuserList.data.data) || [];
    console.log("getsuserValue", getsuserList);
    let dropdownusermaster =
      getsuserValue &&
      getsuserValue.map(({ id, name }) => ({
        label: name,
        value: id,
      }));
    setuserlist(dropdownusermaster);
  };

  const getRestarantmaster = async () => {
    let getsoutletList = await getMlmfoutletMaster();

    let getsoutletValue = (getsoutletList && getsoutletList.data.data) || [];

    let restarantmaster = getsoutletValue.map(({ id, name }) => ({
      label: name,
      value: id,
    }));

    setoutletlist(restarantmaster);
  };

  const getFreeDeliveryMenuList = async () => {
    let restaurantId = selectedrestarant.value;
    let customerId = selectedusers.value;
    let getDplanList = await getFreeDeliveryListMaster(
      restaurantId,
      customerId
    );
    console.log("getDplanList", getDplanList);
    let getListValue = getDplanList?.data?.data || [];
    console.log("getListValue", getListValue);
    setCustomerFreeDely(getListValue);
  };

  const getCustomerAddresIDmaster = async (e) => {
  
    let customerId = e;
    let getsAddres = await getcustomerAdrsIDMaster(customerId);
    console.log("getsAddres", getsAddres);

    let getsIDmasterValue = (getsAddres && getsAddres.data.data) || [];

    let CustomerAddIDmaster = getsIDmasterValue.map(
      ({ addressId, address }) => ({
        label: address,
        value: addressId,
      })
    );

    setCustomerAddresID(CustomerAddIDmaster);
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    setcomonPopupModal(!comonPopupModal);
    setIsview(false);
    setIsedit(false);
  };

  const saveFreeDeliverycustomerlist = async () => {
  

    console.log("selectedAdres", selectedAdres);

    let data = "";
    let setDate1 =
      startDate.getFullYear() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getDate();
    let setDate2 =
      endDate.getFullYear() +
      "-" +
      (endDate.getMonth() + 1) +
      "-" +
      endDate.getDate();

    let multi =
      selectedAdres &&
      selectedAdres.map((item) => {
        // console.log("item",item);
        return item["value"].toString();
      });
      let multiText = multi.toString();
    data = {
      outletCode: selectedrestarant.value,
      customerId: selectedusers.value,
      fromDate: setDate1,
      toDate: setDate2,
      addressId: multiText,
      status: "A",
    };
    console.log("data", data);
   
    let reqforupload;
    reqforupload = await saveFreeDeliveryREQ(data);

    if (reqforupload?.status === 200) {
      setIsview(false);
      setIsedit(false);
      setcomonPopupModal(false);
      setSelectedAdres([]);
      getFreeDeliveryMenuList();
      if (!isedit) {
        swal("Success!", "Free Delivery list Added", "success");
      } else {
        swal("Success!", "Free Delivery list Updated", "success");
      }
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setcomonPopupModal(!comonPopupModal);
      setSelectedAdres([]);
    }
  };

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;
    if (key == "address") {
      if (!value) {
        addFieldValue = { [value]: null };
        errorsLocal["address"] = " Please select Menu";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        // setSelectedAdres({
        //   label: value.label,
        //   value: value.value,
        // });
        addFieldValue = { ["address"]: value.value };
        errorsLocal["address"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "fromDate") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["fromDate"] = " Please Select Date";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["fromDate"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "toDate") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["toDate"] = " Please Select Date";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["toDate"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = [{ ...FreeDelyDetail }];
    newFormData[key] = value;
    setFreeDelyDetail(newFormData);
  };

  const CustomClearText = () => "clear all";

  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "blue" : "black",
  });

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#4cb32b",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  const columns = [
    {
      name: "customerName",
      label: "Customer Name",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        viewColumns: false,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "customerId",
      label: "Customer ID",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        viewColumns: false,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "outletName",
      label: "Outlet Name",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        viewColumns: false,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "outletCode",
      label: "Outlet Code",
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "addressId",
      label: "Address ID",
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "addressName",
      label: "Address",
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "fromDate",
      label: "From Date",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        viewColumns: false,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "toDate",
      label: "To Date",
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
  ];

  const options = {
    filter: false,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    // viewColumns:false,
    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    // search: false,
    // textLabels: {
    // 	body: {
    // 		noMatch: labelmessage
    // 	},
    // },

    fixedHeader: true,
    tableBodyHeight: "425px",

    fixedSelectColumn: true,
    search: false,
    // page: currentPage,

    pagination: false,
    serverSide: true,
    // rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    // onColumnSortChange: this.customSort,
    onChangePage: (page) => this.changePage(page),
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterVal,
      filterOptions,
      changedColumnIndex,
      displayData
    ) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        this.handleFilterSubmit(newFilters);
      }
    },

    onSearchChange: (searchValue) => this.customSearch(searchValue),
    // table's internal filterList
    confirmFilters: true,

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => this.handleFilterSubmit(applyNewFilters)}
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      //// console.log('onFilterConfirm');
      // console.log('filterList', filterList);
    },

    onFilterDialogOpen: () => {
      //// console.log('filter dialog opened');
    },
    onFilterDialogClose: () => {
      //// console.log('filter dialog closed');
    },
  };

  return (
    <div className="row">
      <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12">
        <Card>
          <div class="row">
            <div class="col-3 col-md-3 col-lg-3">
              <div class="form-group">
                <h3 className="me-auto main-hd">Free Delivery</h3>
              </div>
            </div>
            <div class="col-7 col-md-7 col-lg-7 row">
              <Card.Header
                className="card-title main-card"
                style={{ marginLeft: "300px" }}
              >
                <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp">
                  <label as="a" variant="badge badge-rounded badge-danger">
                    Restaurant
                  </label>
                  <Select
                    options={outletlist}
                    value={selectedrestarant}
                    closeMenuOnSelect={false}
                    // search
                    // name="stateCode"
                    placeholder="Choose"
                    // autoComplete="off"
                    onChange={(event) => {
                      setSelectedrestarant(event);
                    }}
                  />
                </div>
                <div
                  class="col-4 col-md-4 col-lg-4 form-group main-frm-grp"
                  style={{ width: "30.333333%",zIndex:"999" }}
                >
                  <label as="a" variant="badge badge-rounded badge-danger">
                    Customer
                  </label>
                  <Select
                    options={userlist}
                    value={selectedusers}
                    closeMenuOnSelect={false}
                    placeholder="choose"
                    autoComplete="off"
                    onChange={(e) => {
                      setSelectedusers(e);
                      getCustomerAddresIDmaster(e.value);
                    }}
                  />
                </div>
                <div
                  class=" col-2 col-md-2 col-lg-2 mt-4  form-group"
                  style={{ width: "9.333333%" }}
                >
                  {/* {selectedusers.value && selectedrestarant.value && */}

                  <Button
                    className="mt-2 btn-primary"
                    variant="success dark btn-sm "
                    // disabled={restarantvalue.value == ""}
                    style={{
                      backgroundColor: "green",
                      borderRadius: "2px",
                      border: "0px solid",
                    }}
                    onClick={() => {
                      getFreeDeliveryMenuList();
                    }}
                  >
                    <i
                      // class="fas fa-plus"
                      onClick={() => {
                        // getoutletMenulist();
                        //  getoutletList();
                      }}
                    >
                      Get{" "}
                    </i>{" "}
                  </Button>

                  {/* } */}
                </div>
                <div class=" col-2 col-md-2 col-lg-2 mt-4 form-group">
                  <Button
                    className="mt-2"
                    variant="success dark btn-sm"
                    // disabled={restarantvalue.value == ""}
                    style={{
                      backgroundColor: "#1F3DB6",
                      borderRadius: "2px",
                      border: "0px solid",
                    }}
                    onClick={(e) => {
                      opnAddNewUserModal(e);
                    }}
                  >
                    <i onClick={() => {}}>Add </i>{" "}
                  </Button>

                  {/* } */}
                </div>
              </Card.Header>
            </div>{" "}
          </div>

          <Card.Body
            className="scroll-tbl-fix-header"
            style={{ padding: "0.875rem" }}
          >
            <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    data={CustomerFreeDely}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
          </Card.Body>
        </Card>

        <Modal
          isOpen={comonPopupModal || deletepopup}
          // toggle={() => onClose()}
          style={{
            maxWidth: comonPopupModal && "600px",
          }}
          backdrop="static"
        >
          <ModalHeader>
            {(deletepopup && " Delete ") ||
              (comonPopupModal && isedit === false
                ? `Add Free Delivery Customer`
                : `Update Free Delivery Customer ${" "}  ${" "}`)}
          </ModalHeader>
          <ModalBody>
            {deletepopup && (
              <>
                <span>
                  Are you sure want to delete item ? <strong> </strong>
                </span>
              </>
            )}

            {comonPopupModal && (
              <>
                <div className="row">
                  {/* <div className="col-sm-6 col-md-6 col-xl-6">
                  <FormGroup>
                    <Label for="customerId">
                      Customer ID<span class="text-danger">*</span>
                    </Label>
                    <Input
                      type="customerId"
                      name="customerId"
                      id="customerId"
                      placeholder="customerId "
                      maxLength="40"
                      required
                      autoComplete="off"
                      onChange={(e) =>
                        onChangeCommonpopupsetOutletvalue("customerId", e.target.value.trimStart())
                      }
                      value={menulistitem?.customerId}
                    />
                    <span style={{ color: "red" }}>{errors["customerId"]}</span>
                  </FormGroup>
                </div> */}

                  <div
                    className="col-sm-6 col-md-6 col-xl-6"
                    style={{ marginTop: "17px",width:"40%" }}
                  >
                    <FormGroup>
                      <label as="a" variant="badge badge-rounded badge-danger">
                        Address <span class="text-danger">*</span>
                      </label>
                      <Select
                        options={CustomerAddresID}
                        // defaultValue={selectedOutletvalue}
                        isMulti
                        //  value={
                        //   selectedCustomerAddresID &&
                        //   selectedCustomerAddresID["value"] != ""
                        //     ? selectedCustomerAddresID
                        //      : ""
                        //  }
                        closeMenuOnSelect={false}
                        styles={{
                          clearIndicator: ClearIndicatorStyles,
                        }}
                        components={{ ClearIndicator }}
                        search
                        name="address"
                        placeholder="Choose"
                        // isDisabled={editmenuavailablity}
                        onChange={(e) => {
                          setSelectedAdres([...e]);
                          onChangeCommonpopupsetOutletvalue("address", e);
                          // console.log("eee", e);
                        }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    <span style={{ color: "red" }}>{errors["address"]}</span>
                  </div>

                  <div
                    className="col-sm-3 col-md-3 col-xl-3"
                    style={{ marginTop: "17px" }}
                  >
                    <FormGroup>
                      <Label for="fromDate">
                        From Date<span class="text-danger">*</span>
                      </Label>
                      <DatePicker
                        dateFormat="yyyy-MM-dd"
                        // selectsStart
                        selected={startDate}
                        minDate={today}
                        //startDate={rangeStart}
                        // endDate={rangeEnd}
                        onChange={(e) => {
                          setDate(e);
                          console.log("eeeee", e);
                          onChangeCommonpopupsetOutletvalue("fromDate", e);
                        }}
                        //value={menulistitem?.startDate}
                      />

                      <span style={{ color: "red" }}>{errors["fromDate"]}</span>
                    </FormGroup>
                  </div>

                  <div
                    className="col-sm-3 col-md-3 col-xl-3"
                    style={{ marginTop: "17px", marginLeft: "13px",width:"20%" }}
                  >
                    <FormGroup>
                      <Label for="toDate">
                        To Date<span class="text-danger">*</span>
                      </Label>

                      <DatePicker
                        dateFormat="yyyy-MM-dd"
                        selectsEnd
                        selected={endDate}
                        minDate={startDate}
                        startDate={startDate}
                        //endDate={rangeEnd}
                        onChange={(e) => {
                          setendDate(e);
                          onChangeCommonpopupsetOutletvalue("toDate", e);
                          console.log("end", e);
                        }}
                        //  value={menulistitem?.endDate}
                      />

                      <span style={{ color: "red" }}>{errors["toDate"]}</span>
                    </FormGroup>
                  </div>
                </div>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            {deletepopup && (
              <>
                <Button
                  variant="success"
                  onClick={() => {
                    // deletemenuitemsubscription();
                    //    deleteitem("Deletemenu");
                  }}
                >
                  Delete
                </Button>
                <Button
                  variant="danger"
                  onClick={() => {
                    //  setDeletepopup(false);
                  }}
                >
                  Cancel
                </Button>
              </>
            )}

            {comonPopupModal && (
              <>
                {isView === false && isedit === false && (
                  <Button
                    variant="primary"
                    className={!formIsValid ? "btn-disabled" : "btn-primary"}
                    disabled={!formIsValid}
                    onClick={() => {
                      saveFreeDeliverycustomerlist();
                    }}
                  >
                    Submit
                  </Button>
                )}
                {isView === false && isedit === true && (
                  <Button
                    variant="contained"
                    className={!formIsValid ? "btn-disabled" : "btn-primary"}
                    disabled={!formIsValid}
                    onClick={() => {
                      // saveupdateSubcribemenulist();
                      // console.log("saveupdateSubcribemenulist", );
                    }}
                  >
                    Update
                  </Button>
                )}

                <Button
                  variant="secondary"
                  onClick={() => {
                    // setMainMenuModal(false);
                    // setSubMenuModal(false);
                    // setMenuFoodItemModal(false);
                    // setOpenImagePopup(false);
                     
                    setcomonPopupModal(false);
                    setIsview(false);
                    setIsedit(false);
                    setDate(new Date());
                    setendDate(new Date());
                    setSelectedAdres([]);
                    setErrors({});
                  }}
                >
                  Cancel
                </Button>
              </>
            )}
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default FreeDelivery;
